import React from 'react';
import { Divider, Chip } from 'material-ui';
import TickIcon from 'material-ui/svg-icons/action/done';
import CrossIcon from 'material-ui/svg-icons/content/clear';
import { lightGreen300, orange300 } from 'material-ui/styles/colors';
import moment from 'moment';

export const yCenter = { display: 'flex', alignItems: 'center' };
export const marginLeft = (px = 12) => ({
    marginLeft: px
});

/**
 * helper function for formatting date in Redux form
 */
export const formatDate = value => {
    if (value === '') {
        return null;
    }
    return typeof value === 'string' ? new Date(value) : value;
};

export const getFieldPath = (sectionPrefix, fieldName) => {
    if (sectionPrefix) {
        return sectionPrefix.charAt(sectionPrefix.length - 1) === ']'
            ? sectionPrefix + fieldName
            : sectionPrefix + '.' + fieldName;
    }
    return fieldName;
};

export const BooleanField = ({ value }) => (value ? <TickIcon /> : <CrossIcon />);

export const DateComponent = ({ date, text = '', format = 'DD MMM YYYY HH:mm' }) => {
    if (!date) {
        return null;
    }
    const formatted = moment(date).format(format);
    return (
        <span>
            {text ? text + ' ' : ''}
            {formatted}
        </span>
    );
};

export const DotDivider = () => <span style={{ margin: '0px 5px' }}>.</span>;

export const Split = () => (
    <div className={'row'} style={{ marginTop: 12, marginBottom: 12 }}>
        <Divider />
    </div>
);

export const RowSection = ({ leftContent, leftYCenter = true, rightContent, hideSplit, style = {} }) => {
    return (
        <div style={style}>
            <div key={'main'} className={'row'}>
                <div className={'col-sm-3'}>
                    {leftContent && leftYCenter ? React.cloneElement(leftContent, { style: yCenter }) : leftContent}
                </div>
                <div className={'col-sm-9'}>{rightContent}</div>
            </div>
            {!hideSplit ? <Split key={'split'} /> : null}
        </div>
    );
};

const isCampaignActive = (active, startDate, endDate) => {
    if (!active) {
        return false;
    }
    if (active && (!startDate || !endDate)) {
        return true;
    }
    // Remove comparing time. Only date.
    const start = moment(moment(startDate).format('LL'), 'LL');
    const end = moment(moment(endDate).format('LL'), 'LL');
    const current = moment(moment().format('LL'), 'LL');
    return start.isSameOrBefore(current) && current.isSameOrBefore(end);
};

export const ActiveLabel = ({ active, startDate, endDate }) => {
    const isActive = isCampaignActive(active, startDate, endDate);
    const isActiveLabel = isActive ? 'Active now' : 'Not active now';
    return (
        <div>
            <h4 style={{ marginBottom: 4 }}>Status</h4>
            <Chip backgroundColor={isActive ? lightGreen300 : orange300}>{isActiveLabel}</Chip>
        </div>
    );
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/helpers.js
 **/